import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "OptionalFiltersButtonWrapper" }
const _hoisted_2 = {
  key: 0,
  class: "OptionalFilterBlockTextWrapper"
}
const _hoisted_3 = {
  key: 1,
  class: "OptionalFiltersCounter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass([
			'OptionalFilterBlock',
			_ctx.panelVisible || _ctx.isInternal ? 'NarrowBlock' : ''
		])
    }, [
      (!_ctx.panelVisible && !_ctx.isInternal)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "OptionalFilterBlockText" }, " Add filters ", -1 /* CACHED */)
          ])))
        : _createCommentVNode("v-if", true),
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "lnr-plus OptionalFilterBlockIcon" }, null, -1 /* CACHED */)),
      (_ctx.doesAtLeastOneFilterHaveSelectedOption)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.selectedFiltersCounter), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ]))
}